import { createSelector } from 'reselect'

const selectState = (state) => state.freeNav

const selectDevices = createSelector(selectState, (state) => state.devices)

const selectIsFetching = createSelector(
  selectState,
  (state) => state.isFetching
)

export { selectIsFetching, selectDevices }
